import { useContext } from 'react'
import { NotificationContext } from 'contexts/component/NotificationContext'

const useNotification = () => {
  const context = useContext(NotificationContext)

  if (!context)
    throw new Error(
      'NotificationContext must be placed within NotificationProvider'
    )

  return context
}

export default useNotification
